import React from 'react'
import SongPreview, { FloatingPlayer } from '../ui/SongPreview'
import { deserializeSong } from '../../helpers/songSerializer'

const InlineSongPreview = ({ serializedValue}) => {
  const song = deserializeSong(serializedValue)
  return (
    <FloatingPlayer>
      <SongPreview {...song} />
    </FloatingPlayer>
  )
}

export default InlineSongPreview
